import { smCssVar } from '../../../../../plugins/Salemoche-Wordpress-Essentials/assets/src/js/helpers.js'
import DeviceDetector from "device-detector-js";

const deviceDetector = new DeviceDetector();
const device = deviceDetector.parse(window.navigator.userAgent);

/**
*========================================
*	
*	Slick Slider
*	
*========================================
*/

(function($) {
    
    window.salemoche = {...window.salemoche}

    window.salemoche.breakpoints = {
        small: 414,
        medium: 768,
        large: 1024,
        xlarge: 1440
    }

    window.salemoche.baseColors = {
        light: '#E2D6B8',
        regular: '#C6AE70',
        dark: '#4C3200',
    }

    window.salemoche.language = $('html').attr('lang');

    $(window).on('load', () => {

        $('.sci-loading').addClass('inactive');

        /**
        *========================================
        *	
        *	Get Colors
        *	
        *========================================
        */

        // window.salemoche.themes.forEach((theme, index) => {
        //     console.log(index);
        // });
        // Object.keys(window.salemoche.themes).forEach((theme, index) => {
        //     console.log(theme.indexOf(window.salemoche.themes[theme]));
        // });

    })

    setTimeout(() => {
        $('.sci-loading').addClass('inactive');
    }, 5000);

    $(document).on('ready', () => {

        $('body').addClass(`browser-${device.client.name.toLowerCase()}`)


        /**
        *========================================
        *	
        *	Call Functions
        *	
        *========================================
        */


        setTimeout(() => {
            responsiveChange();
        }, 100);

        $(window).on('resize', responsiveChange);

        function responsiveChange () {
            calculateBreakpoint();

            // if (window.salemoche.currentBreakpoint == 'xlarge') {
            //     $('.sci-overview .sci-tile:nth-of-type(3), .sci-overview .sci-tile:nth-of-type(2), .sci-overview .sci-tile:nth-of-type(1)').addClass('open')
            //     $('.sci-overview .sci-tile:nth-of-type(3), .sci-overview .sci-tile:nth-of-type(2), .sci-overview .sci-tile:nth-of-type(1)').removeClass('closed')
            //     $('.sci-home .sci-left .sci-tile, .sci-home .sci-home__preview .sci-tile').removeClass('closed');
            //     $('.sci-home .sci-left .sci-tile, .sci-home .sci-home__preview .sci-tile').addClass('open');
            // }
            
            // if (window.salemoche.currentBreakpoint == 'large' || window.salemoche.currentBreakpoint == 'medium') {
            //     $('.sci-overview .sci-tile:nth-of-type(3)').removeClass('open');
            //     $('.sci-overview .sci-tile:nth-of-type(3)').addClass('closed');
            //     $('.sci-overview .sci-tile:nth-of-type(2), .sci-overview .sci-tile:nth-of-type(1)').addClass('open');
            //     $('.sci-overview .sci-tile:nth-of-type(2), .sci-overview .sci-tile:nth-of-type(1)').removeClass('closed');
            //     $('.sci-home .sci-left .sci-tile, .sci-home .sci-home__preview .sci-tile').removeClass('closed');
            //     $('.sci-home .sci-left .sci-tile, .sci-home .sci-home__preview .sci-tile').addClass('open');
            // }

            // if (window.salemoche.currentBreakpoint == 'small') {
            //     $('.sci-tile').removeClass('open');
            //     $('.sci-tile').addClass('closed');
            // }
        }

        /**
        *========================================
        *	
        *	Setup Settings
        *	
        *========================================
        */
        
        let searchText = window.salemoche.language == 'de' ? 'Suchen' : 'Search';
        $('.ecsa-search-icon').append(`<button>${searchText}</button>`);

        /**
        *========================================
        *	
        *	Icons & Graphics
        *	
        *========================================
        */
        

        $('.sci-tile').each( function () {
            let tile = $(this)
            let type = tile.data('type');
            let currentType = window.salemoche.types[type];
            let theme = tile.data('theme');
            let currentTheme = window.salemoche.themes[theme];
            // let themeColors = currentTheme?.colors || window.salemoche.baseColors;
            let venue = tile.data('venue');
            let currentVenue = window.salemoche.venues[venue];
            let colors = currentVenue?.colors || window.salemoche.baseColors;
        
            $(this).find('.sci-type-icon, .sci-theme-icon').each( function () {

                let iconContainer = $(this);
                let icon;
                if (!currentVenue) return
                
                if (iconContainer.hasClass('sci-type-icon')) {
                    if (currentType) {
                        icon =  $(currentType.icon);  

                        if(currentType.page_url) {
                            iconContainer.attr('href', currentType.page_url);
                            iconContainer.attr('title', type + ' icon & link');
                        }
                    }

                } 
                // else {
                //     if (currentTheme) {
                //         icon =  $(currentTheme.icon);  
                //         tile.attr('data-color-light', colors.light);
                //         tile.attr('data-color-regular', colors.regular);
                //         tile.attr('data-color-dark', colors.dark);
                        
                //         if(currentTheme.page_url) {
                //             iconContainer.attr('href', currentTheme.page_url)
                //             iconContainer.attr('title', theme + ' icon & link');
                //         }
                //     }
                // }

                if (!icon) return;
                icon.find('path').css('fill', colors.regular);
                icon.find('title').remove();
                iconContainer.html(icon);
            })

            $(this).find('.sci-image-placeholder').each( function () {
                let imageContainer = $(this);
                let icon =  $(window.salemoche.eyeGraphic);
                icon.find('path').css('fill', colors.regular);
                imageContainer.html(icon);
            })

            $(this).css('background-color', colors.light);
            $(this).css('color', colors.dark);
            $(this).find('.sci-tile__body__link, .sci-tile__body__link__icon').css('color', colors.dark);


            // Themengebiete on the Home Page
            
            let imageContainer = $(this).find('.sci-image-themengebiet')
            if (!currentTheme) return
            let icon =  $(currentTheme.icon);  
            icon.find('path').css('fill', window.salemoche.baseColors.dark);
            imageContainer.html(icon);
        });

        addSvgGraphic($('.sci-footer__background'))

        function addSvgGraphic(element, graphic = $(window.salemoche.eyeGraphic), colors = window.salemoche.baseColors) { 
            graphic.find('path').css('fill', colors.light);
            element.html(graphic);
        }

        /**
        *========================================
        *	
        *	Theme Colors
        *	
        *========================================
        */

        $('.sci-filter-item-theme[data-theme]').each( function () {
            let that = $(this);
            let theme = that.data('theme');
            let currentTheme = window.salemoche.themes[theme];

            if (!currentTheme) return
            
            let icon = $(currentTheme.icon);
            // const colors = currentTheme.colors;
            const colors = window.salemoche.baseColors;

            icon.find('path').css('fill', colors.dark);
            that.find('.sci-filter-item-icon').html(icon);
            that.css('background-color', colors.light);
            that.css('color', colors.dark);

            window.salemoche.currentTheme = currentTheme;
        })

        if ($('.sci-event, .sci-exhibition').length != 0) {
            let bodyClasses = $('.sci-event, .sci-exhibition')[0].classList
            let themeKeys = Object.keys(window.salemoche.themes);

            bodyClasses.forEach(bodyClass => {
                if (themeKeys.includes(bodyClass)) {
                    window.salemoche.currentTheme = window.salemoche.themes[bodyClass];
                    smCssVar('--color-current-light', window.salemoche.currentTheme.colors.light);
                    smCssVar('--color-current-regular', window.salemoche.currentTheme.colors.regular);
                    smCssVar('--color-current-light', window.salemoche.currentTheme.colors.light);
                    $('.sci-footer__background').find('path').css('fill', window.salemoche.currentTheme.colors.light);
                }
            });
        }

        Object.keys(window.salemoche.venues).forEach(venue => {
            $(`*[data-venue*=${venue}]:not(.sci-home__information__links__link-container)`).css('background', window.salemoche.venues[venue].colors.light);
            $(`*[data-venue*=${venue}]:not(.sci-home__information__links__link-container)`).css('color', window.salemoche.venues[venue].colors.dark);
            $(`*[data-venue*=${venue}].sci-home__information__links__link-container a`).css('background', window.salemoche.venues[venue].colors.light);
            $(`*[data-venue*=${venue}].sci-home__information__links__link-container a`).css('color', window.salemoche.venues[venue].colors.dark);
        })

        /**
        *========================================
        *	
        *	Add Tile Theme Id & Venue ID
        *	
        *========================================
        */
        

        $('.sci-tile').each(function () {
            let theme = $(this).data('theme');

            if (!theme || !window.salemoche.themes[theme]) return
            
            let themeId = window.salemoche.themes[theme].id

            $(this).attr('data-theme-id', themeId);
        })
        

        $('.sci-tile').each(function () {
            let venue = $(this).data('venue');

            if (!venue || !window.salemoche.venues[venue]) return
            
            let venueId = window.salemoche.venues[venue].id

            $(this).attr('data-venue-id', venueId);
        })

        /**
        *========================================
        *	
        *	Add wide class to Column if there is no 3rd column
        *	
        *========================================
        */
        
        $('.sci-columns-container').each(function () {
            if ($(this).find('.sci-column_3').length == 0) {
                $(this).addClass('two-column');
            } else {
                $(this).addClass('three-column');
            }
        })

        /**
        *========================================
        *	
        *	Breakpoints
        *	
        *========================================
        */
        

        function calculateBreakpoint() {
            if (window.innerWidth >= window.salemoche.breakpoints.large) {
                window.salemoche.currentBreakpoint = 'xlarge';
            } else if (window.innerWidth <= window.salemoche.breakpoints.small) {
                window.salemoche.currentBreakpoint = 'small';
            } else if (window.innerWidth <= window.salemoche.breakpoints.medium) {
                window.salemoche.currentBreakpoint = 'medium';
            } else if (window.innerWidth <= window.salemoche.breakpoints.large) {
                window.salemoche.currentBreakpoint = 'large';
            } else {
                window.salemoche.currentBreakpoint = 'small';
            }

        }

        /**
        *========================================
        *	
        *	Filters
        *	
        *========================================
        */
        
        if (window?.salemoche?.dates) {
            let dates = window.salemoche.dates;
            let dateNames = Object.keys(dates);
            dateNames.forEach(dateName => {
                let month = dateName;

                dates[month].days.forEach(day => {
                    let filterButton = $(`<button class="sci-button sci-filter-item sci-filter-item sci-filter-item-date" data-type="date" data-term="${day}. ${month}" style="order: ${dates[month].id};"><?php echo "Some Date" ?>${day}. ${month}</button>`)
                    $('.sci-filters__dates').append(filterButton)
                });
            });
        }

        /**
        *========================================
        *	
        *	Program
        *	
        *========================================
        */
        
        if ($('.sci-program').length != 0) {
            $('.sci-program').find('.sci-program-element').each(function () {
                let element = $(this);
                let type = element.data('type');
                element.appendTo($(`.sci-program-type__container[data-type=${type}`));
            })
        }

    })

})(jQuery)